import * as Service from 'types/service';
import { Box, Divider } from '@tocktix/pantry';
import { DisplayTime } from '@tock/time';
import { EventAttributesActionLocation } from 'utils/analytics/amplitudeEventConstants';
import { ViewMode } from 'routes/authenticated/app/bookings/CalendarAndServiceRoute';
import { css } from '@emotion/react';
import PartyPopoverFooter from 'components/service/party/partyPopover/PartyPopoverFooter';
import ServicePartyCard from 'components/service/party/partyCardRefresh/ServicePartyCard';

interface Props {
  isReadOnly: boolean;
  party: Service.Party;
  viewMode: ViewMode;
  onCancelPurchase(party?: Service.Party): void;
  onClose(): void;
  onEditReservation(actionLocation?: EventAttributesActionLocation): void;
  onOpenParty(): void;
  onRemoveWalkIn(): void;
  onSelectParty(party: Service.Party): void;
}

const PartyPopoverRefresh: React.FC<Props> = ({
  isReadOnly,
  party,
  viewMode,
  onCancelPurchase,
  onClose,
  onEditReservation,
  onOpenParty,
  onRemoveWalkIn,
  onSelectParty,
}) => {
  return (
    <Box data-testid="party-popover-refresh">
      <ServicePartyCard
        bottomLeft={
          party.expectedReservationTime ? (
            <DisplayTime timeValue={party.expectedReservationTime} />
          ) : null
        }
        bottomRight={null}
        onSelectParty={onOpenParty}
        party={party}
        topRight={party.partySize}
      />
      <Box
        css={css`
          margin: 1.2rem -1.2rem;
        `}
      >
        <Divider />
      </Box>
      <PartyPopoverFooter
        party={party}
        isReadOnly={isReadOnly}
        onCancelPurchase={onCancelPurchase}
        onClose={onClose}
        onEditReservation={onEditReservation}
        handleSelectParty={onSelectParty}
        handleRemoveWalkIn={onRemoveWalkIn}
        viewMode={viewMode}
        variant="refresh"
      />
    </Box>
  );
};

export default PartyPopoverRefresh;
